<template>
  <div v-loading="loading" class="page-form page-base">
    <h3 class="title">制票通知单日期特殊修改</h3>
    <affix :error-list="errorList">
      <div class="tools">
        <form-button :loading="loading" name="保存" type="primary" @click="saveData()" />
      </div>
    </affix>

    <div class="form-container">
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="130px"
        :rules="rules"
        :show-message="false"
      >
        <common-title title="基本信息" />
        <el-col :lg="16" :md="12">
          <el-form-item class="bill_no" label="外部制票通知单号">
            <el-input v-model="INVO_INFOID.LOW" placeholder="请输入" />
            <!-- <el-input v-model="INVO_INFOID.HIGH" placeholder="请输入" /> -->
            <span class="tips">(每次修改不能超过2000个)</span>
          </el-form-item>
        </el-col>
        <common-title title="日期选择" />
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="">
              <el-radio-group v-model="radioKey" @change="handleRadioChange">
                <el-radio label="MAK_DATE">开票日期</el-radio>
                <el-radio label="CREATE_DATE">创建日期</el-radio>
                <el-radio label="CHAN_DATE">换票日期</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="开票日期" label-width="70px">
              <el-date-picker v-model="HEAD[radioKey]" type="date" value-format="yyyyMMdd" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { apiUpdateInvoiceDate } from '@/api/sap/system-settings'
import { mapGetters } from 'vuex'
export default {
  data() {
    const rules = {
      prodpl_type: [{ required: true, message: '请选择单据类型', trigger: 'change' }],
      name_soldto: [{ required: true, message: '请选择订单客户', trigger: 'change' }],
      contactor: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
      sals_center: [{ required: true, message: '请选择营销单元', trigger: 'change' }]
    }
    return {
      rules,
      newSave: false,
      errorList: [],
      buttonStatus: {
        save: false // 保存
      },
      radioKey: 'MAK_DATE',
      radioKeys: {
        MAK_FLAG: 'X',
        CREATE_FLAG: '',
        CHAN_FLAG: ''
      },
      conditions: {},
      HEAD: {
        MAK_DATE: '',
        CREATE_DATE: '',
        CHAN_DATE: ''
      },
      INVO_INFOID: {
        'SIGN': 'I',
        'OPTION': 'EQ',
        'LOW': '',
        'HIGH': ''
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  created() {
    this.HEAD[this.radioKey] = this.$utilsCommon.parseTime(new Date().getTime(), '{y}{m}{d}')
  },
  methods: {
    // 保存
    async saveData() {
      this.errorList = []

      this.loading = true
      const params = {
        USER_BP: this.role.USER_BP,
        INVO_INFOID: [this.INVO_INFOID],
        RADIO: this.radioKeys,
        HEAD: this.HEAD
      }
      try {
        this.errorList = []
        const res = await apiUpdateInvoiceDate(params)
        this.loading = false
        if (res.MSGTYPE !== 'S') {
          this.errorList.push(res.MESSAGE)
          return
        }
        this.$message.success(res.MESSAGE)
      } catch (e) {
        this.loading = false
      }
    },
    // 改变按钮状态
    changeButtonStatus(buttons) {
      for (const key in this.buttonStatus) {
        if (buttons.includes(key)) {
          this.buttonStatus[key] = false
        } else {
          this.buttonStatus[key] = true
        }
      }
    },
    handleRadioChange(type) {
      for (const key in this.radioKeys) {
        if (Object.hasOwnProperty.call(this.radioKeys, key)) {
          if (key.split('_')[0] === type.split('_')[0]) {
            this.radioKeys[key] = 'X'
          } else {
            this.radioKeys[key] = ''
          }
          this.HEAD[`${key.split('_')[0]}_DATE`] = ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 10px;
  text-align: left;
  position: relative;
  .btn-header {
    background: #fff;
    position: fixed;
    transform: translate(-10px, -10px);
    z-index: 99;
    width: calc(100% - 273px);
    height: 50px;
    padding: 5px 0 0 10px;
    box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.5);
  }
}
/deep/ .bill_no {
  .el-form-item__content {
    display: flex;
    align-items: center;
    .el-input {
      width: 30% !important;
    }
    .tips {
      font-size: 12px;
      color: #333;
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system-manage/invoiceDateUpdate.vue